import { IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import './ClientePageHeader.css';

const ClientePageHeader: React.FC<{ title: string }> = ({ title }) => (
    <IonHeader className="ion-no-border cliente-page-header">
        <IonToolbar>
            <IonTitle><span className="cliente-page-title">{title}</span></IonTitle>
        </IonToolbar>
    </IonHeader>
);

export default ClientePageHeader;
